import React, { useEffect ,useState} from "react";
import { Form, Row, Col, Button, message } from "antd";
import { ReactSelectField, TextAreaField } from "../../../../atoms/FormElement";
import { useForm } from "react-hook-form";


const RejectPopup = (props) => {

  const { onClose, reasonsData, handleReject,label,type } = props;
  const { control, formState: { errors }, setValue, handleSubmit } = useForm();

  const handleRejection = async (data) => { 
    let payload = {
      "reason": data?.reason?.value,
      "comments": data?.rejectReason,
       
    };

    handleReject && await handleReject(payload);
  };
 let optionData  = reasonsData && [...reasonsData];

 if(type === 'decline_renewal' && reasonsData){
  optionData.push({ value: "other", label: "Other" })
 }
  const buttonTitle = ()=>{
    if(props?.type == "cancel"){
      return "Cancel";
    }else if(props?.type === "decline_renewal"){
      return "Submit";
    }else{
         return "Reject";
    }
  
  }

  const[reason,setReason] = useState()
  return (
    <Form layout="vertical" onFinish={handleSubmit(handleRejection)}>
      <Row gutter={24}>
        {reasonsData?.length > 0 && (
          <Col span={props?.type === "decline_renewal" ? 24 : 12}>
            <ReactSelectField
              label={label ? label : "Select a reason"}
              fieldname="reason"
              iProps={{ placeholder: "Select reasons" }}
              initValue=""
              setValue={setValue}
              onChange={(e)=> setReason(e?.value)}
              isRequired={true}
              control={control}
              rules={{ required: "Required" }}
              validate={errors.reason && "error"}
              validMessage={errors.reason && errors.reason.message}
              selectOption={optionData}
            />
          </Col>
        )}
       {
        ((props?.type === "decline_renewal" && reason === 'other') || props?.type !== "decline_renewal") &&
       <Col span={24}>
          <TextAreaField
             isRequired={(props?.type === "decline_renewal" && reason === 'other') ? true : false}
            label={props?.type === "decline_renewal" ? `Enter a Note:` :`Enter a comment for ${props?.type == "cancel" ? "Cancellation" : "rejection"}:`}
            fieldname="rejectReason"
            iProps={{ placeholder: "Some reason...." }}
            initValue=""
            setValue={setValue}
            control={control}
            rules={{ required: "Reason required" }}
            validate={errors.rejectReason && "error"}
            validMessage={errors.rejectReason && errors.rejectReason.message}
          />
        </Col>}
      </Row>
      <Row gutter={24} justify="space-between">
        <Col>
          <Button size="large" onClick={onClose}>
            Back
          </Button>
        </Col>
        <Col>
          <Button size="large" className="ag-red-button" htmlType="submit">
      {      buttonTitle()}
          
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default RejectPopup;
